import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';

import ReturnManifestDetailProvider from 'providers/ReturnManifestDetailProvider';

import ReturnManifestShipment from 'components/add_return/return-manifest/ReturnManifestDetail/ReturnManifestShipment/ReturnManifestShipment';
import ReturnManifestDetailSummary from 'components/add_return/return-manifest/ReturnManifestDetail/ReturnManifestDetailSummary';

const ReturnManifestDetail = () => {
  const { returnManifestId } = useParams();

  const handleReturnManifestUpdate = useCallback(() => {
    window.dispatchEvent(new CustomEvent('return-manifest-updated'));
  }, []);

  return (
    <ReturnManifestDetailProvider>
      <Row className="mt-1">
        <Col md={9} className="mb-3 mb-md-0">
          <ReturnManifestShipment
            returnManifestId={returnManifestId}
            onReturnManifestUpdate={handleReturnManifestUpdate}
          />
        </Col>

        <Col md={3}>
          <ReturnManifestDetailSummary
            returnManifestId={returnManifestId}
            showActionBtn={true}
            listenToUpdates={true}
          />
        </Col>
      </Row>
    </ReturnManifestDetailProvider>
  );
};

export default ReturnManifestDetail;
